import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import { ReactstrapBadge as Badge } from '@febos-io/design';

import Icon from '../../../../../../components/Icon';
import useTranslation from '../../../../../../hooks/useTranslation';
import { useDesignContext } from '../../../../../../providers';

function VerticalNavMenuLink({ item }) {
  const LinkTag = item.externalLink ? 'a' : NavLink;
  const currentURL = useLocation().pathname;
  const isActive = currentURL === item.to;
  // ** Hooks
  const { navbarI18nNamespace } = useDesignContext();
  const { t } = useTranslation(navbarI18nNamespace);
  return (
    <li
      data-current-url={currentURL}
      data-url-to={item.to}
      data-is-active={isActive}
      className={classnames({
        'nav-item': !item.children,
        disabled: item.disabled
      })}
    >
      <LinkTag
        data-is-active={isActive}
        className={() => 'd-flex align-items-center ' + (isActive ? 'active' : '')}
        target={item.newTab ? '_blank' : undefined}
        /*eslint-disable */
        {...(item.externalLink === true
          ? {
            href: item.to || '/'
          }
          : {
            to: item.to || '/'
          })}
        onClick={(e) => {
          if (
            item.to.length === 0
            || item.to === '#'
            || item.disabled === true
          ) {
            e.preventDefault();
          }
        }}
      >
        <Icon
          icon={item.icon}
          className={classnames('me-1', item.classIcon)}
          {...item.iconProps}
        />
        <span className="menu-item text-truncate">
          {t(item.text)}
        </span>

        {item.badge && item.badgeText ? (
          <Badge
            className="ms-auto me-1"
            color={item.badge}
            pill
          >
            {item.badgeText}
          </Badge>
        ) : null}
      </LinkTag>
    </li>
  );
}

VerticalNavMenuLink.propTypes = {
  item: PropTypes.shape({
    text: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    classIcon: PropTypes.string,
    iconProps: PropTypes.object,
    newTab: PropTypes.bool,
    disabled: PropTypes.bool,
    badge: PropTypes.string,
    badgeText: PropTypes.string,
    children: PropTypes.array,
    externalLink: PropTypes.bool
  }).isRequired
};
export default VerticalNavMenuLink;
